
    import Vue from 'vue';
    import Scroll  from 'components/plugin/scroll'
    import encrypt from 'components/plugin/lib/encrypt.js'
    import AvatarCropper from "vue-avatar-cropper"
    import animate from 'animate.css'

    Vue.filter('amount_convert',function(val){
        return (val/100).toFixed(2)
    })

    export default {
        components: {
            Scroll,
            AvatarCropper
        },
        data () {
            return {
                loading: 1,
                changeList: [],
                apiStatus: true,
                lastRowId: '',
                pageRows: 20,
                bottom: 0,
                ddtoken: '',
                userId: '',
                circleId: '',
                openTitle: '现场位置',
                relationData: null,        // 选择的商家
                mapType: '',
                showTost: false,
                tostContent: '',
                showLocationMap: false,
                submitData: {
                    coverImg:'',            // 封面配图
                    sceneLogo:'',            // 现场logo
                    sceneName: '',          // 现场名称
                    introduction: '',       // 现场描述
                    clockInTime: '0.5',        // 打卡时效
                    clockInDistance:'',     // 打卡距离
                    circle: '',             // 相关公众圈
                    sceneAdmin: '',         // 现场管理员
                    relationData: '',
                    publicWork: false,      // 公开工作信息
                    publicStudy: false,     // 公开学习信息
                    openShop: false,        // 现场商家
                    sceneGroupChat: false,  // 现场群聊
                    defaultLocation: {      // 默认浏览器定位
                        lng: '',
                        lat: '',
                        cityName: '',
                        citycode: '',
                        address: '',
                    },
                    locationMapData: {          // 现场位置
                        lng: '',
                        lat: '',
                        cityName: '',
                        citycode: '',
                        address: '',
                    }
                },
                cropperOptions: {
                    aspectRatio: 1.35,
                    autoCropArea: 1,
                    viewMode: 1,
                    movable: false,
                    zoomable: false
                },
                uploadType: '',
                uploadData: {
                    OSSAccessKeyId: '',
                    success_action_status: '200',
                    signature: '',
                    policy: '',
                    name: '',
                    dir: '',
                    host: '',
                },
                formData: {
                    aaa: '111',
                    bbb: '222',
                },
                uploadHost: '/circle/v1/operating/upload/moreFile',
                coverAvatar: 'http://s1.im-dangdang.com/dev/2019/05/13/1557726047751775.png',
                sceneAvatar: 'http://s1.im-dangdang.com/dev/2019/05/13/1557726047751775.png',
                // sceneAvatar: 'http://s1.im-dangdang.com/dev/2019/05/13/1557715714924993.jpeg',
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                //当用户不存在或ddtoken不存在时return
                if(!to.query.circleId || !to.query.userId) return;
                vm.userId = to.query.userId;
                vm.circleId = to.query.circleId;

                // 线上环境使用线上上传地址
                // var host = window.location.host;
                // if (host.indexOf('dev.im') < 0 && host.indexOf('localhost:8080') < 0) {
                //     vm.uploadHost = '';
                // }
                    
            });
        },
        mounted () {
            // 读取用户缓存数据
            var creatSceneData = sessionStorage.getItem('creatSceneData');
            if (creatSceneData && creatSceneData != '') {
                this.submitData = JSON.parse(creatSceneData);
                if (this.submitData.coverImg != '' ) {
                    this.coverAvatar = this.submitData.coverImg;
                }
                if (this.submitData.sceneLogo != '' ) {
                    this.sceneAvatar = this.submitData.sceneLogo;
                }
            }
            // 读取商家缓存数据
            var relationData = sessionStorage.getItem('relationData');
            if (relationData && relationData != '') {
                this.submitData.relationData = JSON.parse(relationData);
            }

            this.initMap();
        },
        methods: {
            // 初始化地图
            initMap () {
                this.map = new AMap.Map("gdMap", {
                    resizeEnable: true,
                    zoom:12
                });
                this.map.on('click', this.showInfoClick);
                var self = this;
                // 浏览器定位
                this.map.plugin('AMap.Geolocation', function() {
                    var geolocation = new AMap.Geolocation({
                        // 是否使用高精度定位，默认：true
                        enableHighAccuracy: true,
                        // 设置定位超时时间，默认：无穷大
                        timeout: 10000,
                        // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                        buttonOffset: new AMap.Pixel(10, 20),
                        //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                        zoomToAccuracy: true,     
                        //  定位按钮的排放位置,  RB表示右下
                        buttonPosition: 'RB'
                    });
                    geolocation.getCurrentPosition()
                    AMap.event.addListener(geolocation, 'complete', onComplete)
                    AMap.event.addListener(geolocation, 'error', onError)
                    /**
                     * 默认获取用户定位数据
                     * @param {object} data data是具体的定位信息
                     */
                    function onComplete (data) {
                        if (data.position.lng && data.status == 0) {
                            self.addMakers(data.position.lng, data.position.lat);
                            self.openInfo(data.position.lng, data.position.lat,data.formattedAddress);
                            self.map.setCenter(data.position);
                        }
                    }
                    function onError (data) {
                        // 定位出错
                    }
                });
                AMap.plugin(['AMap.Autocomplete','AMap.PlaceSearch'],function(){
                    var autoOptions = {
                        // 城市，默认全国 
                        // city: "北京",
                        // 使用联想输入的input的id
                        input: "tipinput"
                    }
                    var autocomplete= new AMap.Autocomplete(autoOptions)
            
                    var placeSearch = new AMap.PlaceSearch({
                        city:'北京',
                        map: self.map
                    });
                    AMap.event.addListener(autocomplete, 'select', function(e){
                        //TODO 针对选中的poi实现自己的功能
                        var lng = e.poi.location.lng;
                        var lat = e.poi.location.lat;
                        var address = e.poi.district + e.poi.address;
                        
                            self.submitData.locationMapData.lng = lng;
                            self.submitData.locationMapData.lat = lat;
                            self.submitData.locationMapData.address = address;
                            if (e.poi.district && e.poi.district.indexOf('市') >= 0) {
                                var index = e.poi.district.indexOf('市');
                                self.submitData.locationMapData.cityName = e.poi.district.substring(0, index);
                                self.submitData.locationMapData.citycode = e.poi.adcode;
                            }
                            self.addMakers(lng, lat);
                            self.openInfo(lng, lat, address);
        
                    });
                });
            },
            showInfoClick(e){
                this.addMakers(e.lnglat.getLng(),e.lnglat.getLat());
                this.RGeocode(e.lnglat.getLng(),e.lnglat.getLat());
                // getUserGeolocation
            },
            RGeocode (lng, lat) {
                var self = this;
                AMap.plugin('AMap.Geocoder', function() {
                    var geocoder = new AMap.Geocoder({
                        // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                        city: '010'
                    })
                    var lnglat = [lng, lat]
                    geocoder.getAddress(lnglat, function(status, result) {
                        if (result.regeocode && result.regeocode.addressComponent) {
                            var cityName = result.regeocode.addressComponent.province;
                            var citycode = result.regeocode.addressComponent.citycode;
                            self.submitData.locationMapData.cityName = cityName;
                            self.submitData.locationMapData.citycode = citycode;

                        }

                        if (status === 'complete' && result.info === 'OK') {
                            // result为对应的地理位置详细信息
                            
                            self.openInfo(lng, lat, result.regeocode.formattedAddress);
                        }
                    })
                })
            },
            openInfo(lng, lat, text) {
                this.submitData.locationMapData.lng = lng;
                this.submitData.locationMapData.lat = lat;
                this.submitData.locationMapData.address = text;
                //构建信息窗体中显示的内容
                var info = [];
                // info.push("<div class='input-card content-window-card'><div><img style=\"float:left;\" src=\" https://webapi.amap.com/images/autonavi.png \"/></div> ");
                // info.push("<p class='input-item'>电话 : 010-84107000   邮编 : 100102</p>");
                info.push("<div style=\"padding:7px 0px 0px 0px;\"><h4>现场位置</h4>");

                info.push("<p class='input-item'>" + text + "</p></div></div>");
        
                var infoWindow = new AMap.InfoWindow({
                    content: info.join("")  //使用默认信息窗体框样式，显示信息内容
                });
                var point = new AMap.LngLat(lng, lat);
                infoWindow.open(this.map, point);
            },
            addMakers (lng, lat) {
                this.map.clearMap(); // 清除所有覆盖物
                var point = new AMap.LngLat(lng, lat);
                var marker = new AMap.Marker({
                    position: point,   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                    title: '北京'
                });
                marker.on('click', function () {this.RGeocode(lng, lat);});
                this.map.add(marker);
                this.map.setCenter(point);
                this.map.setZoom(16);
            },

            // 提交定位数据
            submitLocationData() {
                if (this.submitData.defaultLocation.lng == '' && this.submitData.locationMapData.lng == '') {
                    this.setTost('请选择现场位置');
                    return;
                }
                if (this.submitData.locationMapData.lng == '') {
                    this.submitData.locationMapData = this.submitData.defaultLocation;
                }
                this.showLocationMap = false;
            },
            // 显示地图
            showMapFun (type) {
                this.showLocationMap = true;
            },
            // 隐藏地图
            hindeMapFun () {
                this.showLocationMap = false;
            },
            // 获取文件上传密钥
            getUploadData (type) {
                // alert(type);
                this.uploadType = type;
                var params = {};
                this.$http.get('/circle/v1/operating/oss/policy', {
                    params: encrypt(params)
                }).then(res => {
                    // alert('成功');
                    var resut = JSON.parse(res.body);
                    this.uploadData.OSSAccessKeyId = resut.accessid;
                    this.uploadData.signature = resut.signature;
                    this.uploadData.policy = resut.policy;
                    this.uploadData.dir = resut.dir;
                    this.uploadData.host = resut.host;
                });
            },
            handleChanged(file, reader) {
            },
            handleUploading (form,xhr) {
                // let file = form.get("file");
                // let uploadData = this.uploadData;
                // form.delete('file');
                // if (file.name != '') {
                //     var suffix = this.get_suffix(file.name);
                //     var key = uploadData.dir + this.random_string(10) + suffix;
                //     form.append('key',key);
                //     if (this.uploadType == 'cover') {
                //         this.submitData.coverImg = uploadData.host + '/' + key;
                //     } else {
                //         this.submitData.sceneLogo = uploadData.host + '/' + key;
                //     }
                    
                // }
                // form.append('name',file.name);
                // form.append('OSSAccessKeyId',uploadData.OSSAccessKeyId);
                // form.append('signature',uploadData.signature);
                // form.append('policy',uploadData.policy);
                // form.append('success_action_status',uploadData.success_action_status);
                // form.append('file',file)
            },
            handleCompleted(response, form, xhr) {

                if (response.status == 1) {
                    this.setTost('上传成功');

                    if (this.uploadType == 'cover') {
                        this.coverAvatar = response.data[0].pictureUrl;
                        this.submitData.coverImg = response.data[0].pictureUrl;
                        // document.getElementById('coverImage').src = response.data[0].pictureUrl;
                        // this.coverAvatar = this.submitData.coverImg;
                    } else {
                        this.sceneAvatar = response.data[0].pictureUrl;
                        this.submitData.sceneLogo = response.data[0].pictureUrl;
                        // this.sceneAvatar = this.submitData.sceneLogo;
                    }
                } else {
                    this.setTost('上传失败' + response.msg);
                }
                // alert(response.data[0].pictureUrl);
                
                // xhr.status
            },
            // 随机获取10为字母
            random_string(len) {
                len = len || 32;
                var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                var maxPos = chars.length;
                var pwd = '';
                for(var i=0;i<len;i++){
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },
            // 获取存储文件名
            get_suffix(filename) {
                var pos = filename.lastIndexOf('.');
                var suffix = '';
                if (pos != -1) {
                    suffix = filename.substring(pos)
                }
                return suffix;
            },
            // 提交现场数据
            submitSceneData () {
                var checkStatus = this.checkData();
                if (checkStatus) {
                    var data = this.getSubmitData();
                    if (this.apiStatus) {
                        this.apiStatus = false;
                        this.createScene(data);
                    } else {
                        this.setTost('正在请求数据，请稍后');
                    }
                    
                }
                // var str = JSON.stringify(this.submitData);
                // document.getElementById('submitDataStr').innerHTML = str;
            },
            // 创建现场请求
            createScene (data) {
                this.$http.get('/circle/v1/operating/scene/add', {
                    params: encrypt(data)
                }).then(res => {
                    this.apiStatus = true;
                    if (res.body.status == 1) {
                        this.setTost('创建现场成功');
                        setTimeout(() => {
                            sessionStorage.setItem('creatSceneData','');
                            sessionStorage.setItem('relationData','');
                            this.defaultData();
                            this.$router.push({name:'Manage'})
                        }, 2000);
                        
                        return;
                    }
                    this.setTost(res.body.msg);
                })
            },
            // 初始化数据
            defaultData() {
                this.coverAvatar = "";
                this.sceneAvatar = "";
                this.submitData = {
                    coverImg:'',            // 封面配图
                    sceneLogo:'',            // 现场logo
                    sceneName: '',          // 现场名称
                    introduction: '',       // 现场描述
                    clockInTime: '0.5',        // 打卡时效
                    clockInDistance:'',     // 打卡距离
                    circle: '',             // 相关公众圈
                    sceneAdmin: '',         // 现场管理员
                    relationData: '',
                    publicWork: false,      // 公开工作信息
                    publicStudy: false,     // 公开学习信息
                    openShop: false,        // 现场商家
                    sceneGroupChat: false,  // 现场群聊
                    defaultLocation: {      // 默认浏览器定位
                        lng: '',
                        lat: '',
                        cityName: '',
                        citycode: '',
                        address: '',
                    },
                    locationMapData: {          // 现场位置
                        lng: '',
                        lat: '',
                        cityName: '',
                        citycode: '',
                        address: '',
                    }
                };
            },
            getSubmitData () {
                var submitData = this.submitData;
                var circleId = this.circleId;
                var userId = this.userId
                // const {submitData, circleId, relationData, userId} = this;
                var submitData = this.submitData;
                var data = {
                    background: JSON.stringify({
                        picture: submitData.coverImg,
                        width: "750",
                        height: "555"
                    }),
                    circleId: circleId,
                    cityName: submitData.locationMapData.cityName,
                    createGroup: submitData.sceneGroupChat ? 1 : 0,
                    desc: submitData.introduction,
                    duration: parseFloat(submitData.clockInTime) * 3600,
                    isAdmin: 1,
                    latitude: submitData.locationMapData.lat,
                    location: JSON.stringify({ 
                        locationName: submitData.locationMapData.cityName, 
                        locationAddress: submitData.locationMapData.address
                    }),
                    circleAccountNum: submitData.circle,
                    longitude: submitData.locationMapData.lng,
                    name: submitData.sceneName,
                    openShop: submitData.openShop ? 1 : 0,
                    publicSchool: submitData.publicStudy ? 1 : 0,
                    publicWork: submitData.publicWork ? 1 : 0,
                    relationId: submitData.relationData.relationId,
                    relationType: submitData.relationData.relationType,
                    sceneId: 0,
                    sceneLogo: JSON.stringify({
                        picture: submitData.sceneLogo,
                        width: "500",
                        height: "500"
                    }),
                    signinDistance: submitData.clockInDistance,
                    userId: userId,
                    userPhone: submitData.sceneAdmin,
                }
                return data;
            },
            // 检查数据
            checkData () {
                var hintData = {
                    coverImg:'请上传封面配图',            // 封面配图
                    sceneLogo:'请上传现场LOGO',            // 现场logo
                    sceneName: '请设置现场名称',          // 现场名称
                    introduction: '请输入现场描述',       // 现场描述
                    clockInTime: '请选择打卡时效',        // 打卡时效
                    clockInDistance:'请输入打卡距离',     // 打卡距离
                    circle: '请设置公众圈',             // 相关公众圈
                    sceneAdmin: '请输入现场管理员',         // 现场管理员
                    locationMapData: '请设置现场位置',
                    relationData: '请选择现场商业',
                };
                for (var k in this.submitData) {
                    switch (k) {
                        // case 'coverImg':
                        // case 'sceneLogo':
                        case 'sceneName':
                        // case 'introduction':
                        case 'clockInTime':
                        case 'clockInDistance':
                        // case 'circle':
                        // case 'sceneAdmin':
                        // case 'relationData':
                            if (this.submitData[k] == '') {
                                this.setTost(hintData[k]);
                                return false;
                            }
                        break;
                        // case 'locationMapData':
                        //     if (this.submitData[k].lng == '') {
                        //         this.setTost(hintData[k]);
                        //         return false;
                        //     }
                        // break;

                    }
                    
                }

                return true;
            },
            // tost提示
            setTost (text) {
                this.showTost = true;
                this.tostContent = text;
                clearTimeout(this.tostTime);
                this.tostTime = setTimeout(()=>{
                    this.showTost = false;
                    this.tostContent = '';
                },1500);
            },

            //  点击搜索商家
            goShopSearch(){
                
                // 缓存用户输入数据
                sessionStorage.setItem('creatSceneData', JSON.stringify(this.submitData));
                this.$router.push({
                    name: 'ShopSearch',
                    query: {
                        circleId: this.circleId,
                        userId: this.userId
                    }
                })
            },
            onBottom () {
                //第一页都不够的话，直接不去加载
                if(this.changeList.length < this.pageRows || this.bottom){
                    this.bottom = 1;
                    return
                }

                if(!this.loading){
                    this.getPage(this.lastRowId)
                }
            },
            goDetail (id, changetype) {
                this.$router.push({
                    name: 'PocketDetail',
                    query: {
                        userId: this.userId,
                        ddtoken: this.ddtoken,
                        tradeId: id,
                        changeType: changetype,
                        circleId: this.circleId
                    }
                })
            }
        }

    }


// WEBPACK FOOTER //
// ./src/components/page/scene/create/createScene.js